// Mock data for Dalaa Beauty Center & Academy
// Multi-language: DE (primary), EN, AR

export const translations = {
  de: {
    nav: {
      home: 'Startseite',
      services: 'Leistungen',
      pricing: 'Preise',
      gallery: 'Galerie',
      contact: 'Kontakt',
      book: 'Termin buchen',
    },
    hero: {
      welcome: 'Herzlich Willkommen bei',
      brand: 'Dalaa Beauty Center & Academy',
      subtitle: '',
      description: 'Ihre Schönheit ist unsere Leidenschaft. Wir bieten professionelle Beauty-Behandlungen für Ihr perfektes Wohlbefinden.',
      bookBtn: 'Jetzt Termin buchen',
      aboutBtn: 'Über uns',
    },
    services: {
      tag: 'Unsere Leistungen',
      title: 'Entdecken Sie unsere Services',
      learnMore: 'Mehr erfahren',
      items: [
        { id: 'hair', name: 'Haare', desc: 'Waschen, Schneiden, Föhnen, Färben, Strähnen & mehr' },
        { id: 'face', name: 'Gesicht', desc: 'Gesichtsbehandlungen, Reinigung & individuelle Pflege' },
        { id: 'nails', name: 'Nägel', desc: 'Maniküre, Pediküre, Gel, Acrylnägel & Nail Art' },
        { id: 'lashes', name: 'Wimpern & Augenbrauen', desc: 'Wimpernverlängerung, Lifting & Augenbrauen-Styling' },
        { id: 'more', name: 'Weitere Services', desc: 'Make-up, Waxing, Beratung und vieles mehr' },
      ],
    },
    about: {
      tag: 'Über Uns',
      title: 'Willkommen in der Welt der Schönheit',
      p1: 'Dalaa Beauty Center & Academy ist Ihr persönlicher Ort für Wohlbefinden, Eleganz und Selbstpflege. Mit Leidenschaft, Erfahrung und höchster Qualität schaffen wir für Sie ein einzigartiges Beauty-Erlebnis.',
      p2: 'Unser Team aus erfahrenen Beauty-Expertinnen begleitet Sie auf dem Weg zu Ihrer schönsten Version – persönlich, professionell und mit Liebe zum Detail.',
      stats: [
        { value: '10+', label: 'Jahre Erfahrung' },
        { value: '5000+', label: 'Zufriedene Kundinnen' },
        { value: '20+', label: 'Beauty Services' },
        { value: '100%', label: 'Qualität & Hygiene' },
      ],
    },
    pricing: {
      tag: 'Unsere Preise',
      title: 'Transparente Preise für jeden Service',
      currency: '€',
      categories: [
        {
          name: 'Haare',
          items: [
            { name: 'Waschen & Föhnen', price: '25' },
            { name: 'Damen Haarschnitt', price: '45' },
            { name: 'Färben (kurze Haare)', price: '60' },
            { name: 'Strähnen / Highlights', price: '90' },
            { name: 'Hochsteckfrisur', price: '70' },
          ],
        },
        {
          name: 'Nägel',
          items: [
            { name: 'Klassische Maniküre', price: '25' },
            { name: 'Gel-Nägel', price: '40' },
            { name: 'Acrylnägel', price: '55' },
            { name: 'Pediküre', price: '35' },
            { name: 'Nail Art Design', price: '15' },
          ],
        },
        {
          name: 'Gesicht & Wimpern',
          items: [
            { name: 'Gesichtsreinigung', price: '50' },
            { name: 'Anti-Aging Behandlung', price: '80' },
            { name: 'Wimpernverlängerung', price: '95' },
            { name: 'Wimpern Lifting', price: '55' },
            { name: 'Augenbrauen Styling', price: '20' },
          ],
        },
      ],
    },
    gallery: {
      tag: 'Galerie',
      title: 'Einblicke in unsere Arbeit',
      subtitle: 'Lassen Sie sich von unseren Ergebnissen inspirieren',
    },
    contact: {
      tag: 'Kontakt',
      title: 'Wir freuen uns auf Sie',
      subtitle: 'Vereinbaren Sie noch heute Ihren Termin',
      form: {
        name: 'Name',
        email: 'E-Mail',
        phone: 'Telefon',
        service: 'Service auswählen',
        date: 'Wunschtermin',
        message: 'Nachricht',
        submit: 'Nachricht senden',
        success: 'Vielen Dank! Wir melden uns bald bei Ihnen.',
      },
      info: {
        addressTitle: 'Adresse',
        address: 'Schönheitsstraße 12, 10115 Berlin',
        phoneTitle: 'Telefon',
        phone: '+49 30 1234 5678',
        emailTitle: 'E-Mail',
        email: 'info@dalaa-beauty.de',
        hoursTitle: 'Öffnungszeiten',
        hours: 'Mo–Fr: 09:00 – 19:00\nSa: 10:00 – 17:00\nSo: Geschlossen',
      },
    },
    booking: {
      title: 'Termin buchen',
      subtitle: 'Wählen Sie Ihren Wunschservice und Termin',
      confirm: 'Termin bestätigen',
      success: 'Ihr Termin wurde erfolgreich angefragt!',
    },
    footer: {
      tagline: 'Ihre Schönheit ist unsere Leidenschaft',
      quickLinks: 'Schnellzugriff',
      services: 'Services',
      contactUs: 'Kontaktieren Sie uns',
      rights: 'Alle Rechte vorbehalten.',
    },
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      pricing: 'Pricing',
      gallery: 'Gallery',
      contact: 'Contact',
      book: 'Book Appointment',
    },
    hero: {
      welcome: 'Welcome to',
      brand: 'Dalaa Beauty Center & Academy',
      subtitle: '',
      description: 'Your beauty is our passion. We offer professional beauty treatments for your perfect well-being.',
      bookBtn: 'Book Appointment',
      aboutBtn: 'About Us',
    },
    services: {
      tag: 'Our Services',
      title: 'Discover Our Services',
      learnMore: 'Learn More',
      items: [
        { id: 'hair', name: 'Hair', desc: 'Wash, Cut, Blow-dry, Coloring, Highlights & more' },
        { id: 'face', name: 'Face', desc: 'Facial treatments, cleansing & individual care' },
        { id: 'nails', name: 'Nails', desc: 'Manicure, Pedicure, Gel, Acrylic & Nail Art' },
        { id: 'lashes', name: 'Lashes & Brows', desc: 'Lash extensions, lifting & brow styling' },
        { id: 'more', name: 'More Services', desc: 'Make-up, Waxing, Consulting and much more' },
      ],
    },
    about: {
      tag: 'About Us',
      title: 'Welcome to the World of Beauty',
      p1: 'Dalaa Beauty Center & Academy is your personal place for well-being, elegance and self-care. With passion, experience and the highest quality, we create a unique beauty experience for you.',
      p2: 'Our team of experienced beauty experts accompanies you on the way to your most beautiful version – personally, professionally and with love for detail.',
      stats: [
        { value: '10+', label: 'Years of Experience' },
        { value: '5000+', label: 'Happy Clients' },
        { value: '20+', label: 'Beauty Services' },
        { value: '100%', label: 'Quality & Hygiene' },
      ],
    },
    pricing: {
      tag: 'Our Pricing',
      title: 'Transparent Prices for Every Service',
      currency: '€',
      categories: [
        {
          name: 'Hair',
          items: [
            { name: 'Wash & Blow-dry', price: '25' },
            { name: "Women's Haircut", price: '45' },
            { name: 'Coloring (short hair)', price: '60' },
            { name: 'Highlights', price: '90' },
            { name: 'Updo Hairstyle', price: '70' },
          ],
        },
        {
          name: 'Nails',
          items: [
            { name: 'Classic Manicure', price: '25' },
            { name: 'Gel Nails', price: '40' },
            { name: 'Acrylic Nails', price: '55' },
            { name: 'Pedicure', price: '35' },
            { name: 'Nail Art Design', price: '15' },
          ],
        },
        {
          name: 'Face & Lashes',
          items: [
            { name: 'Facial Cleansing', price: '50' },
            { name: 'Anti-Aging Treatment', price: '80' },
            { name: 'Lash Extensions', price: '95' },
            { name: 'Lash Lifting', price: '55' },
            { name: 'Eyebrow Styling', price: '20' },
          ],
        },
      ],
    },
    gallery: {
      tag: 'Gallery',
      title: 'Insights into Our Work',
      subtitle: 'Let our results inspire you',
    },
    contact: {
      tag: 'Contact',
      title: 'We Look Forward to Meeting You',
      subtitle: 'Book your appointment today',
      form: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        service: 'Select Service',
        date: 'Preferred Date',
        message: 'Message',
        submit: 'Send Message',
        success: 'Thank you! We will get back to you soon.',
      },
      info: {
        addressTitle: 'Address',
        address: 'Schönheitsstraße 12, 10115 Berlin',
        phoneTitle: 'Phone',
        phone: '+49 30 1234 5678',
        emailTitle: 'Email',
        email: 'info@dalaa-beauty.de',
        hoursTitle: 'Opening Hours',
        hours: 'Mon–Fri: 09:00 – 19:00\nSat: 10:00 – 17:00\nSun: Closed',
      },
    },
    booking: {
      title: 'Book Appointment',
      subtitle: 'Choose your service and preferred time',
      confirm: 'Confirm Booking',
      success: 'Your appointment has been requested successfully!',
    },
    footer: {
      tagline: 'Your beauty is our passion',
      quickLinks: 'Quick Links',
      services: 'Services',
      contactUs: 'Contact Us',
      rights: 'All rights reserved.',
    },
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      services: 'الخدمات',
      pricing: 'الأسعار',
      gallery: 'المعرض',
      contact: 'اتصل بنا',
      book: 'حجز موعد',
    },
    hero: {
      welcome: 'مرحباً بكم في',
      brand: 'Dalaa Beauty Center & Academy',
      subtitle: '',
      description: 'جمالك هو شغفنا. نقدم خدمات تجميل احترافية لراحتك المثالية.',
      bookBtn: 'احجز موعدك الآن',
      aboutBtn: 'من نحن',
    },
    services: {
      tag: 'خدماتنا',
      title: 'اكتشفي خدماتنا المميزة',
      learnMore: 'اعرف المزيد',
      items: [
        { id: 'hair', name: 'الشعر', desc: 'غسيل، قص، تجفيف، صبغة، هايلايت والمزيد' },
        { id: 'face', name: 'الوجه', desc: 'علاجات الوجه، تنظيف البشرة والعناية الفردية' },
        { id: 'nails', name: 'الأظافر', desc: 'مانيكير، باديكير، جل، أكريليك ورسم أظافر' },
        { id: 'lashes', name: 'الرموش والحواجب', desc: 'تركيب الرموش، رفع وتصفيف الحواجب' },
        { id: 'more', name: 'خدمات أخرى', desc: 'مكياج، إزالة شعر، استشارات والمزيد' },
      ],
    },
    about: {
      tag: 'من نحن',
      title: 'مرحباً بكم في عالم الجمال',
      p1: 'مركز وأكاديمية دلع للتجميل هو مكانك الخاص للرفاهية والأناقة والعناية الشخصية. بشغف وخبرة وأعلى جودة، نخلق لكِ تجربة جمال فريدة من نوعها.',
      p2: 'فريقنا من خبيرات التجميل المتمرسات يرافقكِ في طريقك إلى نسختك الأجمل – بشكل شخصي ومهني وبحب للتفاصيل.',
      stats: [
        { value: '+10', label: 'سنوات خبرة' },
        { value: '+5000', label: 'عميلة سعيدة' },
        { value: '+20', label: 'خدمة تجميل' },
        { value: '100%', label: 'جودة ونظافة' },
      ],
    },
    pricing: {
      tag: 'أسعارنا',
      title: 'أسعار شفافة لكل خدمة',
      currency: '€',
      categories: [
        {
          name: 'الشعر',
          items: [
            { name: 'غسيل وتجفيف', price: '25' },
            { name: 'قص شعر للسيدات', price: '45' },
            { name: 'صبغة (شعر قصير)', price: '60' },
            { name: 'هايلايت', price: '90' },
            { name: 'تسريحة مرفوعة', price: '70' },
          ],
        },
        {
          name: 'الأظافر',
          items: [
            { name: 'مانيكير كلاسيكي', price: '25' },
            { name: 'أظافر جل', price: '40' },
            { name: 'أظافر أكريليك', price: '55' },
            { name: 'باديكير', price: '35' },
            { name: 'تصميم رسم أظافر', price: '15' },
          ],
        },
        {
          name: 'الوجه والرموش',
          items: [
            { name: 'تنظيف بشرة', price: '50' },
            { name: 'علاج مكافحة الشيخوخة', price: '80' },
            { name: 'تركيب رموش', price: '95' },
            { name: 'رفع رموش', price: '55' },
            { name: 'تصفيف حواجب', price: '20' },
          ],
        },
      ],
    },
    gallery: {
      tag: 'المعرض',
      title: 'لمحات من أعمالنا',
      subtitle: 'دعي نتائجنا تلهمك',
    },
    contact: {
      tag: 'اتصل بنا',
      title: 'نتطلع للقائك',
      subtitle: 'احجزي موعدك اليوم',
      form: {
        name: 'الاسم',
        email: 'البريد الإلكتروني',
        phone: 'الهاتف',
        service: 'اختاري الخدمة',
        date: 'الموعد المفضل',
        message: 'الرسالة',
        submit: 'إرسال الرسالة',
        success: 'شكراً لكِ! سنتواصل معكِ قريباً.',
      },
      info: {
        addressTitle: 'العنوان',
        address: 'Schönheitsstraße 12, 10115 Berlin',
        phoneTitle: 'الهاتف',
        phone: '+49 30 1234 5678',
        emailTitle: 'البريد الإلكتروني',
        email: 'info@dalaa-beauty.de',
        hoursTitle: 'ساعات العمل',
        hours: 'الإثنين–الجمعة: 09:00 – 19:00\nالسبت: 10:00 – 17:00\nالأحد: مغلق',
      },
    },
    booking: {
      title: 'حجز موعد',
      subtitle: 'اختاري الخدمة والموعد المفضل',
      confirm: 'تأكيد الحجز',
      success: 'تم طلب موعدك بنجاح!',
    },
    footer: {
      tagline: 'جمالك هو شغفنا',
      quickLinks: 'روابط سريعة',
      services: 'الخدمات',
      contactUs: 'تواصلي معنا',
      rights: 'جميع الحقوق محفوظة.',
    },
  },
};

export const galleryImages = [
  'https://images.unsplash.com/photo-1580618672591-eb180b1a973f?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
  'https://images.unsplash.com/photo-1589710751893-f9a6770ad71b?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
  'https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
  'https://images.pexels.com/photos/34930126/pexels-photo-34930126.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  'https://images.pexels.com/photos/1654834/pexels-photo-1654834.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  'https://images.unsplash.com/photo-1659391542239-9648f307c0b1?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
  'https://images.unsplash.com/photo-1762373349045-c2decd4ec3f3?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
  'https://images.pexels.com/photos/6135675/pexels-photo-6135675.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
];

export const heroRoses = [
  'https://images.unsplash.com/photo-1582794543139-8ac9cb0f7b11?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
  'https://images.unsplash.com/photo-1623776025811-fd139155a39b?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
  'https://images.unsplash.com/photo-1599180439865-2735aa19840f?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
];

export const teamMembers = [
  { name: 'Sarah Müller', role: 'Senior Stylist', img: 'https://images.unsplash.com/photo-1580618672591-eb180b1a973f?crop=entropy&cs=srgb&fm=jpg&w=400&q=80' },
  { name: 'Layla Ahmed', role: 'Nail Artist', img: 'https://images.unsplash.com/photo-1659391542239-9648f307c0b1?crop=entropy&cs=srgb&fm=jpg&w=400&q=80' },
  { name: 'Anna Weber', role: 'Beauty Expert', img: 'https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?crop=entropy&cs=srgb&fm=jpg&w=400&q=80' },
];
